module.exports = __webpack_public_path__ + "img/vecabo-label.42355a62.png";